import { IoWarningOutline } from "react-icons/io5";

export const NoData = () => (
  <div className="p-4 text-center">
    <IoWarningOutline className="mx-auto text-primaryPurple-100" size={40} />
    <span>No Data Available</span>
  </div>
);
